import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const InconsistentLicenseFlag: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InconsistentLicenseFlag" */ '../src/InconsistentLicenseFlag.tsx'
			)
		).InconsistentLicenseFlag,
});
